import { isTabletFormFactor } from './mobileView';
import { isMobileShellLayout } from './mobileShellLayout';

/**
 * Web tablet layouts outside the mobile app shell.
 * Native tablets always use the app shell, so this stays false there.
 */
export function isDynamicPricingTabletLayout() {
  return isTabletFormFactor() && !isMobileShellLayout();
}

/** KPI cards: 2×2 on tablet, 4-across on wide desktop. */
export function getDynamicPricingKpiGridSx(isTablet = false) {
  return {
    display: 'grid',
    gridTemplateColumns: {
      xs: 'minmax(0, 1fr)',
      sm: 'repeat(2, minmax(0, 1fr))',
      ...(isTablet ? {} : { lg: 'repeat(4, minmax(0, 1fr))' }),
      xl: 'repeat(4, minmax(0, 1fr))',
    },
    gap: { xs: 1.5, sm: 2 },
    alignItems: 'stretch',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  };
}

/** Charts: stack on tablet; side-by-side from xl. */
export function getDynamicPricingChartsGridSx(isTablet = false) {
  return {
    display: 'grid',
    gridTemplateColumns: {
      xs: 'minmax(0, 1fr)',
      ...(isTablet ? {} : { lg: 'minmax(0, 2fr) minmax(0, 1fr)' }),
      xl: 'minmax(0, 2fr) minmax(0, 1fr)',
    },
    gap: { xs: 2, sm: 3 },
    alignItems: 'stretch',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  };
}
